import { Alert, ToasterAlertProvider as ToasterAlertProviderTrilogy } from '@trilogy-ds/react/lib/components/alert';
/**
 * Alert Component
 * @param iconName {IconName} Custom icon
 * @param title {string} Alert title content
 * @param description {string|ReactNode} Alertt description content
 * @param status {StatusState} Status Variant (INFO|SUCCESS|WARNING|ERROR)
 * @param onClick {Function} onClick Event for all alert
 * @param display {Boolean} Display Alert component
 * - ------------------ WEB PROPERTIES -----------------------
 * @param className {string} Additionnal CSS Classes
 * @param testId {string} Test Id for Test Integration
 */
export default Alert;
var ToasterAlertProvider = ToasterAlertProviderTrilogy;
export { ToasterAlertProvider };
//# sourceMappingURL=Alert.js.map